import React, { useMemo, useState } from "react";
import { Button, Collapse } from "reactstrap";
import classnames from "classnames";

// constants
import { SETTINGS_COLLAPSES } from "../../../constants";

// types


// components
import AppSimpleBar from "../../../components/AppSimpleBar";
import UserCoverImage from "./UserCoverImage";
import UserProfile from "./UserProfile";
import PersonalInfo from "./PersonalInfo";
import ThemeSettings from "./ThemeSettings";
import Privacy from "./Privacy";
import Security from "./Security";
import Help from "./Help";
import { useProfile } from "../../../hooks/useProfile";
import { defaultSettings, SettingsTypes } from "../../../types/profile";

interface CollapseItemTypes {
  value:
  | SETTINGS_COLLAPSES.PROFILE
  | SETTINGS_COLLAPSES.HELP
  | SETTINGS_COLLAPSES.PRIVACY
  | SETTINGS_COLLAPSES.SECURITY
  | SETTINGS_COLLAPSES.THEME;
  label: string;
  icon: string;
  component: React.ReactNode;
}

interface AccordianItemProps {
  item: CollapseItemTypes;
  selectedMenu: SETTINGS_COLLAPSES | null;
  onChange: (id: SETTINGS_COLLAPSES | null) => void;
}

const AccordianItem = ({ item, selectedMenu, onChange }: AccordianItemProps) => {
  const isOpen = selectedMenu === item.value;

  return (
    <div className="accordion-item">
      <div className="accordion-header">
        <Button
          color="none"
          className={classnames(
            "accordion-button",
            "font-size-14",
            "fw-medium",
            { collapsed: !isOpen }
          )}
          onClick={() => onChange(isOpen ? null : item.value)}
        >
          <i className={classnames("text-muted", "me-3", item.icon)} />
          {item.label}
        </Button>
      </div>

      <Collapse isOpen={isOpen} className="accordion-collapse">
        {item.component}
      </Collapse>
    </div>
  );
};

const Index = () => {
  // ✅ estado local
  const [settings, setSettings] = useState<SettingsTypes>(defaultSettings);

  //Usuario logado
  const { profile, updateProfile } = useProfile();


  const userBasicDetails = useMemo(() => {
    // console.log('[userBasicDetails],profile', profile)
    if (!profile) return settings.basicDetails;

    const result = {
      ...settings.basicDetails,
      firstName: profile.name,
      lastName: profile.enterprise,
      fullName: profile.name,
      avatar: profile.avatar ?? settings.basicDetails.avatar,
      cover: profile.avatar ?? settings.basicDetails.cover,
      email: profile.email ?? "",
      role: profile.role,
      enterprise: profile.enterprise,
      location: "Brasil, BRA"
    };

    // console.log('[userBasicDetails]. result', result)
    return result;
  }, [profile, settings.basicDetails]);

  // 🔄 substitui updateSettings do redux
  const onChangeData = (field: string, value: any) => {
    setSettings(prev => {
      // proteção runtime (opcional, mas recomendado)
      if (!(field in prev)) {
        console.warn(`[Settings] Campo inválido ignorado: ${field}`);
        return prev;
      }

      return {
        ...prev,
        [field]: value,
      };
    });
  };

  const [selectedMenu, setSelectedMenu] = useState<SETTINGS_COLLAPSES | null>(
    null
  );

  const collapseItems: CollapseItemTypes[] = [
    {
      value: SETTINGS_COLLAPSES.PROFILE,
      label: "Informação usuário",
      icon: "bx bxs-user",
      component: <PersonalInfo basicDetails={userBasicDetails} />,
    },
    {
      value: SETTINGS_COLLAPSES.THEME,
      label: "Tema",
      icon: "bx bxs-adjust-alt",
      component: (
        <ThemeSettings
          theme={settings.theme}
          onChangeData={onChangeData}
        />
      ),
    },
    {
      value: SETTINGS_COLLAPSES.PRIVACY,
      label: "Privacidade",
      icon: "bx bxs-lock",
      component: (
        <Privacy
          privacy={settings.privacy}
          onChangeSettings={onChangeData}
        />
      ),
    },
    {
      value: SETTINGS_COLLAPSES.SECURITY,
      label: "Segurança",
      icon: "bx bxs-check-shield",
      component: (
        <Security
          security={settings.security}
          onChangeSettings={onChangeData}
        />
      ),
    },
    {
      value: SETTINGS_COLLAPSES.HELP,
      label: "Ajuda",
      icon: "bx bxs-help-circle",
      component: <Help />,
    },
  ];

  return (
    <div className="position-relative">
      <UserCoverImage
        basicDetails={userBasicDetails}
      />

      <UserProfile
        basicDetails={userBasicDetails}
        status={settings.status}
      />

      <AppSimpleBar className="user-setting">
        <div className="accordion accordion-flush">
          {collapseItems.map((item, index) => (
            <AccordianItem
              key={index}
              item={item}
              selectedMenu={selectedMenu}
              onChange={setSelectedMenu}
            />
          ))}
        </div>
      </AppSimpleBar>
    </div>
  );
};

export default Index;
